/** Durée alignée sur MobileSwipeableMessageRow (swipe supprimer). */
export const INBOX_ROW_EXIT_MS = 320;

const pinnedByFolder = new Map<string, Set<number>>();

function pinKey(accountId: number, folder: string): string {
  return `${accountId}\0${folder}`;
}

/** Garde la ligne à l’écran le temps de l’anim, même si snapshot/tombstone l’ont déjà retirée. */
export function pinInboxRowExitUids(accountId: number, folder: string, uids: number[]): void {
  if (uids.length === 0) return;
  const key = pinKey(accountId, folder);
  let set = pinnedByFolder.get(key);
  if (!set) {
    set = new Set();
    pinnedByFolder.set(key, set);
  }
  for (const uid of uids) {
    if (uid > 0) set.add(uid);
  }
}

export function unpinInboxRowExitUids(accountId: number, folder: string, uids: number[]): void {
  const key = pinKey(accountId, folder);
  const set = pinnedByFolder.get(key);
  if (!set) return;
  for (const uid of uids) {
    set.delete(uid);
  }
  if (set.size === 0) pinnedByFolder.delete(key);
}

export function isInboxRowExitPinned(accountId: number, folder: string, uid: number): boolean {
  if (uid <= 0) return false;
  return pinnedByFolder.get(pinKey(accountId, folder))?.has(uid) === true;
}

export function getPinnedInboxRowExitUids(accountId: number, folder: string): ReadonlySet<number> {
  return pinnedByFolder.get(pinKey(accountId, folder)) ?? new Set();
}
